/*eslint-disable*/ export const messages = JSON.parse("{\"radio-group.label.optional\":[\"Valgfri\"],\"radio-group.validation.required\":[\"Velg et alternativ.\"]}");
//# sourceMappingURL=messages.mjs.map